import { FC, PropsWithChildren } from 'react';

type Props = {
  onClick: () => void;
};

export const SearchModalContentItem: FC<PropsWithChildren<Props>> = ({
  children,
  onClick,
}) => {
  return (
    <div
      className="flex p-3 hover:shadow-xs truncate rounded-xl cursor-pointer border border-gray-200"
      onClick={onClick}
    >
      {children}
    </div>
  );
};
